import isEqual from 'lodash/isEqual';
import {useRef, useEffect, useState, memo} from 'react';
import {Page} from '../../constant/page';
import {IPageContext} from '../../context';
import {IInitialPageProps, IKwAppProps} from '../../type';
import {getKeys} from '../../util/object';

interface IProps extends Pick<IKwAppProps, 'pageProps' | 'Component'> {
  page: Page;
}

/**
 * TODO: 이 훅이 반환하는 여러 값을 getTransitionClassNames 등의 유틸리티 함수로 전달하는 과정이 귀찮다
 * 전역 변수로 관리해서 전달 과정을 생략할 수 있는지 알아보자
 * (특히 SSR 에서 전역 변수는 위험하므로 주의)
 */
export default function useTransitionManager({
  Component,
  pageProps,
  page,
}: IProps) {
  const [recentPages, setRecentPages] = useState<[Page | undefined, Page]>([
    undefined,
    page,
  ]);
  const pageMapRef = useRef<{
    [key in Page]?: Pick<IProps, 'Component' | 'pageProps'> & {
      prevPage: Page | undefined;
      initialPageProps: IInitialPageProps;
      context: IPageContext;
    };
  }>({});

  let pageMap = pageMapRef.current;
  const pageData = pageMap[page];
  if (!pageData) {
    pageMap = {
      ...pageMap,
      [page]: {
        pageProps,
        Component: memo(Component),
        initialPageProps: Component.initialPageProps,
        context: DEFAULT_PAGE_CONTEXT,
      },
    };
    for (const page2 of getKeys(pageMap)) {
      if (!IMPORTANT_PAGES.includes(page2) && !recentPages.includes(page2)) {
        delete pageMap[page2];
      }
    }
  } else if (!isEqual(pageData.pageProps, pageProps)) {
    // TODO: 리액트 concurrent mode 를 위해 렌더링 중에 ref 값 수정하지 않기
    pageData.pageProps = pageProps;
  }
  useEffect(() => {
    pageMapRef.current = pageMap;
  });

  if (recentPages[1] !== page) {
    setRecentPages(v => [v[1], page]);
  }

  return {
    pageMap,
    prevPage: recentPages[0],
    currentPage: recentPages[1],
  };
}

export const DEFAULT_PAGE_CONTEXT: IPageContext = {
  title: '',
};

const IMPORTANT_PAGES: Page[] = [Page.Home, Page.Content, Page.Viewer];
